var React = require('react');

function Wedge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M56.41,1.65c8.47-4.14,17.52,4.5,13.62,13L46.86,65.29a10.13,10.13,0,0,1-16.16,3l-27.22-26A9.88,9.88,0,0,1,6,26.3Z","transform":"translate(-0.41 -0.58)"}));
}

Wedge.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 70.56 70.55"};

module.exports = Wedge;

Wedge.default = Wedge;
